// ** MUI Theme Provider
import { deepmerge } from '@mui/utils';
import { type ThemeOptions } from '@mui/material/styles';

// ** Type Import
import type { Settings } from '../context/settingsContext';

// ** Theme Override Imports
import palette from './palette';
import spacing from './spacing';
import shadows from './shadows';
import overrides from './overrides';
import breakpoints from './breakpoints';

const getThemeOptions = (settings: Settings): ThemeOptions => {
  // ** Vars
  const { mode, direction, themeColor, contentPadding } = settings;

  // ** Create New object before removing user component overrides and typography objects from userThemeOptions

  const mergedThemeConfig: ThemeOptions = {
    breakpoints: breakpoints(),
    shadows: shadows(mode),
    direction,
    components: overrides(settings),
    palette: palette(settings),
    ...spacing,
    shape: {
      borderRadius: 6,
    },
    mixins: {
      contentPadding: (multiplier: number) => `${0.25 * contentPadding * multiplier}rem`,
    },
    transitions: {
      duration: {
        shortest: 150,
        shorter: 250,
        short: 300,
        standard: 400,
        complex: 600,
        enteringScreen: 225,
        leavingScreen: 195,
      },
    },
  };

  return deepmerge(mergedThemeConfig, {
    palette: {
      primary: {
        ...(mergedThemeConfig.palette
          ? mergedThemeConfig.palette[themeColor]
          : palette(settings).primary),
      },
    },
  });
};

export default getThemeOptions;
